import React from 'react';
import { APP_VERSION } from '../version';

const VersionBadge = () => {
  return (
    <div 
      className="fixed bottom-2 right-2 z-50 px-2 py-1 bg-slate-800/80 text-slate-300 text-xs font-mono rounded shadow-lg backdrop-blur-sm"
      title="Build version (Central Time)"
    >
      {APP_VERSION}
    </div>
  );
};

export default VersionBadge;
